import './SkeletonAvatar-e00fff32.css';

var classes = {"SkeletonAvatar":"prc-SkeletonAvatar-SkeletonAvatar-inefu"};

export { classes as default };
